import React, { useEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { ChevronLeft, ChevronRight } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import { Spotlight, useSpotlight } from '@components/Spotlight';
import { TutorialStepProps } from '../CapaViewTutorial';

const TutorialStep4 = ({ handleNextStep }: TutorialStepProps) => {
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const { load, width, height } = useSpotlight();
  useEffect(() => {
    const $button = document.getElementById('viewer-chat-button');
    $button?.click();
  }, []);

  return (
    <>
      {load && (
        <Spotlight
          cutOutTarget={matches ? { x: '93%', y: 24 } : { x: '5%', y: '50%' }}
          radiusSize={matches ? 56 : 419}
          CTATitle={
            <Box display={'flex'} alignItems={'center'}>
              {matches ? (
                <>
                  주석 아이콘 클릭
                  <ChevronRight color={colorSet.primary500} size={26} />
                </>
              ) : (
                <>
                  <ChevronLeft color={colorSet.primary500} size={26} />
                  주석목록 확인
                </>
              )}
            </Box>
          }
          CTADirection={matches ? 'left' : 'right'}
          CTADescription={
            matches
              ? '내가 남긴 주석과 답글을 수정하거나 삭제할 수도 있어요.'
              : '주석 목록을 클릭하여 프로젝트에 남겨진 모든 주석을 확인하고 관리할 수 있어요.'
          }
          handleNextStep={() => handleNextStep(matches ? '4-2' : '5')}
          addX={matches ? 50 : 300}
          addY={matches ? 80 : 0}
          clientHeight={height}
          clientWidth={width}
          zIndex={10000}
        />
      )}
    </>
  );
};

export default TutorialStep4;
